import * as types from "./actionTypes";

export function beginApiCall() {
    return { type: types.BEGIN_API_CALL };
}

export function apiCallError() {
    return { type: types.BEGIN_API_ERROR };
}

export function apiCallUnAuthorised(){
    return { type: types.BEGIN_API_UNAUTHORISED }
}



// WEBPACK FOOTER //
// ./src/redux/actions/apiStatusActions.js